"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBracketTimingInfo = exports.parseBracketTiming = exports.parseTimingString = void 0;
// Lightly adapted from the wallaby timing plugin. It now allows case insensitive
// t= or T= and is set up to help identify where in the overall bracket string the
// timing part was found
const BRACKET_REGEX = /(?:^|\s|\[)([t|T]=[0-9|:]+)([\s|\]|-].*)?$/;
// The timing string part must consist only of numbers and colons
const TIMING_STRING_REGEX = /^[0-9|:]+$/;
// This takes a string like :33 or 0:33 or 1:00:00 and converts to a number
const parseTimingString = (timeString) => {
    // Only allow colons and numeric characters
    if (!TIMING_STRING_REGEX.test(timeString)) {
        return NaN;
    }
    // parts are delineated by brackets. We support 0, 1 or 2
    const timeParts = timeString.split(':');
    // if we wind up with 4 parts we have 3 colons and it's invalid
    if (timeParts.length > 3) {
        return NaN;
    }
    // each part other than the first must have at least 2 digits. So, you
    // CAN write 1:40 but not 1:4.  Similarly you can write :40 but not ::40
    const badPartIndex = timeParts.findIndex((part, index) => index > 0 && part.length < 2);
    if (badPartIndex > -1) {
        return NaN;
    }
    // reverse the parts so we can start with seconds
    const orderedParts = [...timeParts].reverse();
    // now map each part to the value in seconds
    const secondsPerPart = orderedParts.map((part, index) => {
        // if the part's length is 0, it means we started with an empty colon,
        // and that's ok (we already barfed if it wasn't at the beginning) so
        // just return zero for that part
        if (part.length === 0) {
            return 0;
        }
        // Now parse the part and multiply by the correct part time unit
        // (parts[1] is minutes and parts[2] is hours
        const partsMultiplier = [1, 60, 60 * 60][index];
        return parseInt(part) * partsMultiplier;
    });
    // now sum the array values
    return secondsPerPart.reduce((partial, next) => partial + next, 0);
};
exports.parseTimingString = parseTimingString;
const parseBracketTiming = (bracketText) => {
    const match = BRACKET_REGEX.exec(bracketText);
    if (match) {
        const text = match[1];
        const timeString = {
            text,
            index: bracketText.indexOf(text),
        };
        const seconds = (0, exports.parseTimingString)(text.substring(2));
        if (!isNaN(seconds)) {
            return {
                seconds,
                timeString,
            };
        }
    }
    return {
        seconds: 0,
    };
};
exports.parseBracketTiming = parseBracketTiming;
const getBracketTimingInfo = (bracket) => {
    const isExcluded = !!bracket.attrs.untimed;
    return {
        ...(0, exports.parseBracketTiming)(bracket.textContent),
        isExcluded,
    };
};
exports.getBracketTimingInfo = getBracketTimingInfo;
